import React from 'react';
import { ClipboardList, Users, Scale, Phone, FileText, ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
import { useInView } from '../hooks/useInView';
const items = [{
  icon: ClipboardList,
  title: 'Plan Familiar de Emergencia',
  desc: 'Pasos claros para actuar si ICE llega'
}, {
  icon: Users,
  title: 'Hoja de Custodia de Menores',
  desc: 'Protege a tus hijos legalmente'
}, {
  icon: Scale,
  title: 'Tarjeta de Derechos Legales',
  desc: 'Tus derechos en una sola hoja imprimible'
}, {
  icon: Phone,
  title: 'Lista de Contactos Clave',
  desc: 'Abogados, organizaciones y números de emergencia'
}, {
  icon: FileText,
  title: 'Checklist de Documentos',
  desc: 'Todo lo que debes tener organizado'
}];
export function ActionKit() {
  const [headerRef, headerInView] = useInView();
  const [listRef, listInView] = useInView();
  const [bottomRef, bottomInView] = useInView();
  return <section className="py-16 bg-[#1a56a0] text-white border-t border-white/10 overflow-hidden" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div ref={headerRef} className={`text-center mb-12 animate-on-scroll ${headerInView ? 'in-view' : ''}`} data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 uppercase tracking-wide" data-id="element-4">
            El Kit de Acción Inmediata
          </h2>
          <p className="text-white/70 font-serif italic text-lg text-center mb-6" data-id="element-5">
            Guía Principal + 5 Imprimibles Prácticos
          </p>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto" data-id="element-6" />
        </div>

        <div ref={listRef} className="w-full" data-id="element-7">
          <div className="space-y-4" data-id="element-8">
            {items.map((item, index) => <div key={index} className={`flex items-start space-x-4 p-5 rounded-lg bg-white/5 border border-white/5 hover:bg-white/10 transition-colors animate-on-scroll delay-${index} ${listInView ? 'in-view' : ''}`} data-id="element-9">
                <div className="flex-shrink-0 p-2.5 rounded-full bg-white text-[#c0392b] shadow-md" data-id="element-10">
                  <item.icon className="w-6 h-6" data-id="element-11" />
                </div>
                <div data-id="element-12">
                  <h4 className="font-bold text-white text-base sm:text-lg mb-1" data-id="element-13">
                    {item.title}
                  </h4>
                  <p className="text-sm text-white/60 leading-snug" data-id="element-14">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Bottom Callout */}
        <div ref={bottomRef} className={`mt-12 text-center animate-on-scroll delay-4 ${bottomInView ? 'in-view' : ''}`} data-id="element-15">
          <div className="border border-[#c0392b]/30 bg-[#c0392b]/5 p-8 rounded-xl" data-id="element-16">
            <p className="text-xl md:text-2xl font-serif text-white mb-6" data-id="element-17">
              Todo esto por solo{' '}
              <span className="inline-block bg-white text-[#c0392b] font-black text-3xl sm:text-4xl md:text-5xl px-4 py-1.5 rounded shadow-lg -rotate-2 mx-1 leading-none" data-id="element-18">
                $17.89
              </span>
              <br className="sm:hidden" data-id="element-19" />— más barato que tu lonche de la
              semana 🌮
            </p>
            <a href="https://neurolecturaspro.com/cart/46679258759403:1" onClick={trackAddToCart} className="cta-pulse cta-shimmer group relative inline-flex items-center justify-center px-8 py-5 bg-[#c0392b] text-white font-bold uppercase tracking-widest text-base sm:text-lg hover:bg-[#e74c3c] hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1a56a0] w-full sm:w-auto overflow-hidden rounded-md" data-id="element-20">
              <span data-id="element-21">🛡️ DESCARGAR MI GUÍA Y BONOS AHORA</span>
              <ArrowRight className="ml-3 w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-22" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}